import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { ItemTypeMetadata } from '../../../common-shared-module/model/dyn-form/form-metadata/item-type-metadata.enum';
import { DataSourceItemMetadata, DataSourceItemMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/item/datasource-item-metadata.model';
import { ItemMetadata } from '../../../common-shared-module/model/dyn-form/form-metadata/item/item-metadata.model';
import { ExtendedLayoutMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/layout/extends-layout.metadata.model';
import { LayoutMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/layout/layout-metadata.model';
import { RowLayoutMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { SectionLayoutMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/layout/section-layout.model';
import { MetadataFactory } from '../../../common-shared-module/model/dyn-form/form-metadata/metadata.factory';
import { CreatedLayout } from '../../models/created-layout-model';
import { CreatedRow } from '../../models/created-row.model';
import { CreatedWidget } from '../../models/created-widget.model';
import { Layout } from '../../models/layout.model';
import { MetadataChange } from '../../models/metadata-change.model';
import { MovedLayout } from '../../models/moved-layout.model';
import { MovedRow } from '../../models/moved-row.model';
import { MovedWidget } from '../../models/moved-widget.model';
import { RemovedRow } from '../../models/removed-row.model';
import { RemovedWidget } from '../../models/removed-widget.model';
import { RowLayout } from '../../models/row-layout.model';
import { SelectedLayout } from '../../models/selected-layout.model';
import { SelectedWidget } from '../../models/selected-widget.model';
import { TransferredWidget } from '../../models/transferred-widget.model';

@Injectable({
    providedIn: 'root'
})
export class SectionMetadataService {

    sectionMetadata: SectionLayoutMetadataBase = MetadataFactory.createSectionLayout()
    protected rowsRegistry: Map<RowLayout, RowLayoutMetadataBase> = new Map()
    protected layoutRegistry: Map<Layout, ExtendedLayoutMetadataBase> = new Map()


    init() {
        this.sectionMetadata = MetadataFactory.createSectionLayout()
        this.rowsRegistry.clear()
        this.layoutRegistry.clear()
    }

    findLayout(id: string): SelectedLayout | null {
        let result: SelectedLayout | null = null

        this.layoutRegistry.forEach((v: LayoutMetadataBase, k: Layout) => {
            if (k.id() == id) {
                result = { row: k, index: -1 }
                return
            }
        })

        return result
    }

    findWidget(id: string): SelectedWidget | null {
        let result: SelectedWidget | null = null

        this.rowsRegistry.forEach((v: RowLayoutMetadataBase, k: RowLayout) => {
            let widget = k.widgets.filter(p => p.id() == id)
            if (widget.length > 0) {
                result = { row: k, widget: widget[0], index: -1 }
                return
            }
        })

        return result
    }

    clearState(section: SectionLayoutMetadataBase) {
        this.sectionMetadata = section
        this.rowsRegistry.clear()
        this.layoutRegistry.clear()
    }

    movedRow(event: MovedRow): MetadataChange {

        let metadataChanged: MetadataChange = new MetadataChange()
        if (event.destinyLayout == null && event.originLayout == null) {
            moveItemInArray(this.sectionMetadata.items, event.fromIndex, event.toIndex)
            metadataChanged.pushChanged(this.sectionMetadata)
            return metadataChanged
        }

        let rowM = this.rowsRegistry.get(event.currentRow)
        let rowUp = this.rowsRegistry.get(event.rowUp)

        if (event.destinyLayout == event.originLayout) {
            let layout = <ExtendedLayoutMetadataBase> this.layoutRegistry.get(<Layout> event.destinyLayout)
            let fromIndex = layout.items.findIndex(p => p == rowM)
            let toIndex = layout.items.findIndex(p => p == rowUp)
            moveItemInArray(layout.items, fromIndex, toIndex)
            metadataChanged.pushChanged(layout)
            return metadataChanged
        }

        if (event.originLayout) {
            this.removeRowFromLayout(metadataChanged, event.originLayout, <RowLayoutMetadataBase>rowM)
        } else {
            let index = this.sectionMetadata.items.findIndex(p => p == rowM)
            this.sectionMetadata.items.splice(index, 1)
            metadataChanged.pushDelete(<RowLayoutMetadataBase>rowM).pushChanged(this.sectionMetadata)
        }

        if (event.destinyLayout) {
            let layout = <ExtendedLayoutMetadataBase> this.layoutRegistry.get(event.destinyLayout)
            layout.items = []
            event.destinyLayout.rows.forEach(element => {
                layout.items.push(<RowLayoutMetadataBase>this.rowsRegistry.get(element))
            })

            metadataChanged.pushChanged(layout)
        } else {
            let index = this.sectionMetadata.items.findIndex(p => p == rowUp)
            if (event.fromIndex < event.toIndex) {
                this.sectionMetadata.items.splice(index + 1, 0, <RowLayoutMetadataBase>rowM)
            } else {
                this.sectionMetadata.items.splice(index, 0, <RowLayoutMetadataBase>rowM)
            }

            metadataChanged.pushChanged(this.sectionMetadata)
        }

        return metadataChanged
    }

    protected removeRowFromLayout(metadataChanged: MetadataChange, layout: Layout, rowM: RowLayoutMetadataBase): void {
        let layoutM = <ExtendedLayoutMetadataBase> this.layoutRegistry.get(layout)

        let index = layoutM.items.findIndex(p => p == rowM)
        layoutM.items.splice(index, 1)

        if (layoutM.items.length == 0) {
            let indexS = this.sectionMetadata.items.findIndex(p => p == layoutM)
            this.sectionMetadata.items.splice(indexS, 1)
            this.layoutRegistry.delete(layout)
            metadataChanged.pushChanged(this.sectionMetadata).pushDelete(layoutM)
            return
        }

        metadataChanged.pushChanged(layoutM)
    }

    removedRow(event: RemovedRow): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rowM = this.rowsRegistry.get(event.row)
        this.rowsRegistry.delete(event.row)
        metadataChanged.pushDelete(<RowLayoutMetadataBase>rowM)
        if (event.row.layout) {
            this.removeRowFromLayout(metadataChanged, event.row.layout, <RowLayoutMetadataBase>rowM);
            return metadataChanged
        }

        this.sectionMetadata.items = this.sectionMetadata.items.filter(e => e != rowM)
        return metadataChanged.pushChanged(this.sectionMetadata)
    }

    createdRow(event: CreatedRow): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rm = event.row.metadata
        metadataChanged.pushChanged(rm)
        this.rowsRegistry.set(event.row, rm)

        if (event.row.layout == null) {
            this.sectionMetadata.items.splice(event.index, 0, rm)
            metadataChanged.pushChanged(this.sectionMetadata)
            return metadataChanged
        }

        let extendedLayoutMetadata = this.layoutRegistry.get(event.row.layout)
        if (extendedLayoutMetadata == null) {
            return metadataChanged
        }

        let index = event.row.layout.rows.findIndex(p => p == event.row)
        extendedLayoutMetadata.items.splice(index, 0, rm)
        metadataChanged.pushChanged(extendedLayoutMetadata)
        return metadataChanged
    }

    createdLayout(event: CreatedLayout): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rp = event.layout.layout()
        this.layoutRegistry.set(event.layout, rp)

        let rm = event.row.metadata
        this.rowsRegistry.set(event.row, rm)
        rp.items.push(rm)

        this.sectionMetadata.items.splice(event.index, 0, rp)
        return metadataChanged.pushChanged(rp).pushChanged(rm).pushChanged(this.sectionMetadata)
    }

    movedLayout(event: MovedLayout): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let layout = this.layoutRegistry.get(event.layout)
        let row = this.rowsRegistry.get(event.row)
        let toIndex = this.sectionMetadata.items.findIndex(p => p == row)
        let fromIndex = this.sectionMetadata.items.findIndex(p => p == layout)

        moveItemInArray(this.sectionMetadata.items, fromIndex, toIndex);
        return metadataChanged.pushChanged(<ExtendedLayoutMetadataBase> layout).pushChanged(<RowLayoutMetadataBase> row).pushChanged(this.sectionMetadata)
    }


    removedWidget(event: RemovedWidget): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rm = <RowLayoutMetadataBase> this.rowsRegistry.get(event.row)
        if (rm == null) {
            return metadataChanged
        }
        rm.items.splice(event.index, 1);
        return metadataChanged.pushChanged(rm)
    }


    movedWidget(event: MovedWidget): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rm = <RowLayoutMetadataBase> this.rowsRegistry.get(event.row)
        if (rm == null) {
            return metadataChanged
        }
        moveItemInArray(rm.items, event.fromIndex, event.toIndex);
        return metadataChanged.pushChanged(rm)

    }


    createdWidget(event: CreatedWidget): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rm = <RowLayoutMetadataBase> this.rowsRegistry.get(event.row)
        if (rm == null) {
            return metadataChanged
        }

        let item = event.widget.item()
        rm.items.splice(event.toIndex, 0, item);
        return metadataChanged.pushChanged(rm)

    }


    transferredWidget(event: TransferredWidget): MetadataChange {
        let metadataChanged: MetadataChange = new MetadataChange()

        let rmSource = <RowLayoutMetadataBase> this.rowsRegistry.get(event.sourceRow)
        if (rmSource == null) {
            return metadataChanged
        }
        
        let rmDestiny = <RowLayoutMetadataBase> this.rowsRegistry.get(event.destinyRow)
        if (rmDestiny == null) {
            return metadataChanged
        }

        transferArrayItem(
            rmSource.items,
            rmDestiny.items,
            event.sourceIndex,
            event.destinyIndex,
        );

        return metadataChanged.pushChanged(rmSource).pushChanged(rmDestiny)

    }

    getItemMetadata(event: SelectedWidget): ItemMetadata | undefined {
        let rm = <RowLayoutMetadataBase> this.rowsRegistry.get(event.row)
        if (rm == null) {
            return undefined
        }
        return rm.items[event.index]
    }

    searchFamily(item: DataSourceItemMetadata): DataSourceItemMetadata[] {
        let parents = this.searchParentSelect(item, [])
        let childs = this.searchChildSelect(item, [])

        return [...parents, item, ...childs]
    }

    searchParentSelect(item: DataSourceItemMetadata, currentParents: DataSourceItemMetadata[]): DataSourceItemMetadata[] {
        this.rowsRegistry.forEach((k, v) => {

            v.widgets.forEach(i2 => {
                if (i2.item() instanceof DataSourceItemMetadataBase) {
                    if (item.parentSelectFieldName == i2.item().fieldName) {
                        currentParents = this.searchParentSelect(<DataSourceItemMetadataBase> i2.item(), [<DataSourceItemMetadataBase> i2.item(), ...currentParents,])
                    }
                }
            })
        })

        return currentParents
    }

    searchChildSelect(item: DataSourceItemMetadata, currentParents: DataSourceItemMetadata[]): DataSourceItemMetadata[] {
        this.rowsRegistry.forEach((k, v) => {


            v.widgets.forEach(i2 => {
                if (i2.item() instanceof DataSourceItemMetadataBase) {
                    if ((<DataSourceItemMetadataBase> i2.item()).parentSelectFieldName == item.fieldName) {
                        currentParents = this.searchChildSelect(<DataSourceItemMetadataBase> i2.item(), [...currentParents, <DataSourceItemMetadataBase> i2.item(),])
                    }

                }
            })


        })
        return currentParents
    }

    findSingleSelect(except: DataSourceItemMetadata): DataSourceItemMetadata[] {

        let result: DataSourceItemMetadata[] = []
        this.rowsRegistry.forEach((k, v) => {


            v.widgets.forEach(i2 => {
                if (i2.item() instanceof DataSourceItemMetadataBase && i2.item().type == ItemTypeMetadata.Select) {
                    let family = this.searchFamily(<DataSourceItemMetadataBase> i2.item())
                    if (family.length == 1 && i2.item() != except) {
                        result.push(<DataSourceItemMetadataBase> i2.item())
                    }
                }
            })


        })

        return result
    }

}
